export default "__VITE_ASSET__BkNCdf4i__"